const ContainerRoad = ({ road, containerRefs, password, realname, userImage, nivel }) => {
  return null;
};

export default ContainerRoad;
